const config = {
    url: {
        SAVEDLISTFAV: '/savedlist?id=myFavorites',
    },
};

export default config;
